function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 1.375V31.625",
  stroke: "#8A8A8A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.375 6.875H13.0625C11.7861 6.875 10.5621 7.38203 9.65955 8.28455C8.75703 9.18707 8.25 10.4111 8.25 11.6875C8.25 12.9639 8.75703 14.1879 9.65955 15.0905C10.5621 15.993 11.7861 16.5 13.0625 16.5H19.9375C21.2139 16.5 22.4379 17.007 23.3405 17.9095C24.243 18.8121 24.75 20.0361 24.75 21.3125C24.75 22.5889 24.243 23.8129 23.3405 24.7155C22.4379 25.618 21.2139 26.125 19.9375 26.125H8.25",
  stroke: "#8A8A8A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollar-sign.eea6772ae53d382a4cc281c81e6c944e.svg";
export { ForwardRef as ReactComponent };